module.exports = __webpack_public_path__ + "img/logo.dccd8f83.svg";